import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";
import {Utils} from "@app/utilities/Utils";
import {CreditUnion} from "@app/pages/admin/admin.component";
import {BehaviorSubject, Observable} from "rxjs";
import {PortalUser} from "@app/model/portal-user.model";
import {LoginService} from "@app/login/login.service";

@Injectable({
    providedIn: 'root'
})
export class CreditUnionService {

    private _CUPortalUsers: BehaviorSubject<PortalUser[]> = new BehaviorSubject<PortalUser[]>([]);
    private _AllPortalUsers: BehaviorSubject<PortalUser[]> = new BehaviorSubject<PortalUser[]>([]);
    private _CUPoints: { class: string, id: number, version: number, cuid: string, points: number };

    constructor(private http: HttpClient, private activeUser: LoginService) {
    }

    get portalUsers(): BehaviorSubject<PortalUser[]> {
        this.creditUnionPortalUsers(this.activeUser.getActiveUserSubject().value.cuid)
        return this._CUPortalUsers;
    }

    get flexPoints() {
        this.getFlexPoints(this.activeUser.getActiveUserSubject().value.cuid)
        return this._CUPoints;
    }

    getAllCreditUnions(): Observable<CreditUnion[]> {
        return this.http.get(`/api/secured/creditUnion/getAllCreditUnionInfo`).pipe(
            map((creditUnions: CreditUnion[]) => {
                    return creditUnions.filter(cu => !cu.deconversionDate || this.convertDate(cu.deconversionDate).getTime() > new Date().getTime());
                }
            ), map((creditUnions: CreditUnion[]) => Utils.orderBy(creditUnions, 'name'))) as Observable<CreditUnion[]>
    }

    getAllPortalUsers() {
        this.getUsers()
        return this._AllPortalUsers
    }

    getUsers() {
        this._AllPortalUsers.next([])
        this.http.get('/api/secured/creditUnion/getAllContacts').subscribe((users: PortalUser[]) => {
            this._AllPortalUsers.next(users);
        })
    }

    creditUnionPortalUsers(cuid: string) {
        this._CUPortalUsers.next([])
        this.http.post('/api/secured/creditUnion/getAllPortalUsersByCuid', {cuid: cuid})
            .pipe(map((creditUnions: CreditUnion[]) => Utils.orderBy(creditUnions, 'firstName')))
            .subscribe((users: PortalUser[]) => {
                this._CUPortalUsers.next(users);
            })
    }

    getFlexPoints(cuid: string) {
        return this.http.get(`/api/unsecured/creditUnion/getFlexPointsByCuid/${cuid}`)
    }

    convertDate(date: number): Date {
        if (date) {
            let month, day, year, currentYear = new Date().getFullYear();
            if (date?.toString().length === 5) {
                month = '0' + date?.toString().substr(0, 1)
                day = date?.toString().substr(1, 2)
                year = Number(currentYear.toString().substr(2, 2) <
                date?.toString().substr(3, 2) ? '19' : '20') + date?.toString().substr(3, 2)
            } else {
                month = date?.toString().substr(0, 2)
                day = date?.toString().substr(2, 2)
                year = Number(currentYear.toString().substr(2, 2) <
                date?.toString().substr(4, 2) ? '19' : '20') + date?.toString().substr(4, 2)
            }
            return new Date(year, month, day);
        }
        return new Date(null);
    }
}
